import { Component, inject, OnInit, signal } from '@angular/core';
import {
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { AlertService } from '@context/frontend/alert';
import { applyValidators } from '@context/frontend/form';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton, TuiError, TuiInput } from '@taiga-ui/core';
import { TuiButtonLoading, TuiInputPhone, TuiTextarea } from '@taiga-ui/kit';
import { SupportService } from '../../services';
import {
	DialogBase,
	DialogOptions,
} from '../dialog-base/dialog-base.component';

@Component({
	imports: [
		TuiButton,
		TuiInput,
		FormsModule,
		ReactiveFormsModule,
		TranslocoModule,
		TuiError,
		TuiTextarea,
		TuiInputPhone,
		TuiButtonLoading,
	],
	selector: 'ctx-inquire-dialog',
	templateUrl: 'inquire-dialog.component.html',
})
export class InquireDialogComponent
	extends applyValidators(DialogBase)
	implements OnInit
{
	static override readonly DialogOptions = {
		label: 'support.inquire-header',
		size: 's',
	} as DialogOptions;

	readonly support = inject(SupportService);
	readonly alert = inject(AlertService);

	form: FormGroup | null = null;
	readonly busy = signal(false);

	ngOnInit() {
		this.setupForm();
	}

	setupForm() {
		this.form = new FormGroup({
			email: new FormControl(null, [
				(field) =>
					this.getEmailValidator(field, 'form.error.email.valid'),
				(field) =>
					this.getRequiredValidator(
						field,
						'form.error.email.required',
					),
			]),
			name: new FormControl(null),
			tel: new FormControl(),
			message: new FormControl(),
		});
	}

	onSubmit() {
		this.form?.markAllAsTouched();
		if (this.busy() || !this.form || this.form.invalid) return;
		this.busy.set(true);

		this.form.disable();
		return this.support
			.inquire(this.form.getRawValue())
			.then(() => {
				this.alert.open('inquire-sent').subscribe();
				this.onDismiss();
			})
			.catch((error) => {
				this.alert.open('generic-error').subscribe();
				console.error(error);
				throw new Error(
					'There was an error submitting the inquiry form',
				);
			})
			.finally(() => {
				this.busy.set(false);
				this.form?.enable();
			});
	}
}
